module.exports = __webpack_public_path__ + "media/images/front/icons/register-cc9632c382393d2cc85daa8a19257728.png";